import { Helmet } from 'react-helmet-async';

import EnrollmentsTable from './enrollments-table';



// ----------------------------------------------------------------------

export default function EnrollmentsPage() {
  return (
    <>
      <Helmet>
        <title>Enrollments</title>
      </Helmet>
      <EnrollmentsTable/>
    </>
  );
}
